import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { Typography } from "@material-ui/core"
import IoAnimator from "./IoAnimator"

import * as theme from "../theme"

const Breadcrumbs = props => {
  const { enabled, pathname, post_title } = props
  return (
    <>
      {!!enabled && (
        <Container>
          {pathname !== "/" && (
            <Root to="/">
              <Type color="inherit">Home</Type>
            </Root>
          )}
          <Crumb>
            <Type color="inherit">
              {pathname.startsWith("/service") && "Services / "} {post_title}
            </Type>
          </Crumb>
        </Container>
      )}
    </>
  )
}

Breadcrumbs.defaultProps = { enabled: true }

export default Breadcrumbs

const Container = styled(IoAnimator)`
  @media (min-width: 800px) {
    padding-left: 45px;
    padding-right: 45px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 5%;
  padding-right: 5%;
  display: flex;
  a {
    text-decoration: none;
  }
`
const Root = styled(Link)`
  margin-left: -2px;
  border-radius: 18px 0 0 18px;
  background: white;
  border: 1px solid #a0b9e1;
  padding: 5px 33px 5px 17px;
  color: ${theme.color.background};
`
const Crumb = styled.div`
  cursor: pointer;
  margin-left: -12px;
  padding: 7px 22px 7px 22px;
  color: white;
  background: ${theme.color.background};
  border-radius: 18px;
`

const Type = styled(Typography)`
  font-size: 0.8124rem;
  font-family: "Poppins";
  font-weight: 400;
`
